import {differenceInDays, differenceInMinutes, parse} from 'date-fns';
import {DateFormatEnum} from 'presentation/constants';
import {formatUtcDate} from './convertDate';

export const isTeleconsultationAvailable = (dateAppointment: string) => {
	const appointmentDateFormatted = formatUtcDate(dateAppointment, false);
	const referenceDate = new Date();
	const appointmentDate = parse(
		appointmentDateFormatted,
		DateFormatEnum.DATE_FORMAT_9,
		new Date(),
	);

	const showEnterRoom =
		differenceInDays(appointmentDate, referenceDate) <= 1 &&
		differenceInMinutes(appointmentDate, referenceDate) <= 20 &&
		differenceInMinutes(appointmentDate, referenceDate) >= -19;
	return {
		showEnterRoom,
		date: appointmentDateFormatted,
	};
};
